<h1 class="text-dark text-xl" mat-dialog-title>
  {{ model.id ? 'Modifica marca' : 'Nuova marca' }}
</h1>
<div class="w-full" mat-dialog-content>
  <app-brand-form [closeDialog]="closeDialog" [data]="model"></app-brand-form>
</div>
